import React from 'react';
import { HomeIcon, LandmarkIcon } from 'lucide-react';
import type { ProviderId } from '../../types/aus';
interface ProviderMarkProps {
  provider: ProviderId;
  size?: 'sm' | 'md' | 'lg';
}
const sizes = {
  sm: {
    box: 'h-7 w-7 rounded-lg',
    icon: 'h-4 w-4'
  },
  md: {
    box: 'h-11 w-11 rounded-xl',
    icon: 'h-5 w-5'
  },
  lg: {
    box: 'h-14 w-14 rounded-2xl',
    icon: 'h-7 w-7'
  }
};
export function ProviderMark({
  provider,
  size = 'md'
}: ProviderMarkProps) {
  const s = sizes[size];
  const isFannie = provider === 'fannie';
  const Icon = isFannie ? HomeIcon : LandmarkIcon;
  return <span aria-hidden="true" className={`flex shrink-0 items-center justify-center border ${s.box} ${isFannie ? 'border-brand-200 bg-brand-50 text-brand-700' : 'border-graphite-200 bg-graphite-100 text-graphite-700'}`} data-id="element-165" data-mp="3f0o42xxahgg8">
      <Icon className={s.icon} strokeWidth={2} data-id="element-166" data-mp="3622l51nwnzex" />
    </span>;
}